export const generateStyle = (index: number): number | string => {
  switch (index % 2) {
    case 1: {
      // return 'mt-[128px]'
      return '60%'
    }
    default: {
      // return 'mt-[0]'
      return '0%'
    }
  }
}
